module.exports = __webpack_public_path__ + "static/media/grantspass-small.a0770f1f.webp";